import { BodyTextTwoColumnsFieldsFragment } from 'api/graphql-types';
import React from 'react';
import clsx from 'clsx';
import { sanitizeAndParseHtml } from 'utils/rich-text-renderer/sanitize-and-parse';
import styles from './body-text-two-columns.module.scss';
import bodyTextStyles from '../body-text.module.scss';

interface IBodyTextTwoColumnsProps {
	module: BodyTextTwoColumnsFieldsFragment;
}

const BodyTextTwoColumns = (props: IBodyTextTwoColumnsProps): React.JSX.Element => {
	return (
		<div className={clsx(styles.row, bodyTextStyles.bodyText)}>
			{props.module.leftColumn?.bodyText && (
				<div className={styles.column}>{sanitizeAndParseHtml(props.module.leftColumn?.bodyText)}</div>
			)}
			{props.module.rightColumn?.bodyText && (
				<div className={styles.column}>{sanitizeAndParseHtml(props.module.rightColumn?.bodyText)}</div>
			)}
		</div>
	);
};

export default BodyTextTwoColumns;
